export default function ({app, redirect}) {
    if(!app.$hasPermission('leading')) {
        return redirect(302, '/dashboard');
    }
}